module.exports = __webpack_public_path__ + "static/media/failure_icon.74c047dd.svg";